const FintechNotHiredI18n = {
  title: {
    contractValidationError: 'Unable to validate the contract!',
    productNotHired: 'You have not hired {{ serviceName }} yet.',
    wishToHire: 'I want to hire',
    sasNotFoundClientInformations: 'License information could not be obtained',
    notInBeta: 'Feature in testing phase',
    clickHere: 'Click here'
  },
  service: {
    BOLETO_RAPIDO: 'Boleto Rápido',
    PIX: 'Pix Imediato',
    PAGAMENTO: 'Payments',
    DDA: 'DDA',
    SCORE: 'Sankhya Score',
  },
  message: {
    contractValidationUnexpectedError: 'An unexpected problem was found during the validation process. Please wait a few minutes, if it persists, contact the support team.',
    contractValidationError: 'The following error was found during the validation process: ',
    serviceNotIncludedInCurrentPack: 'The currently contracted service package "{{ package }}" does not include the "{{ serviceName }}" service.',
    clickHereToContractPackage: '{{ hireButton }} to contract a package that includes this service.',
    availableOnlyWhenBankSlipHired: 'This configuration is only available for those who have already hired Boleto Rápido.',
    simpleOperationsWhenBankSlipHired: 'With it, you can issue bank slips simply and integrated with your ERP.',
    availableOnlyWhenPixHired: 'This configuration is only available for those who have already hired Pix Imediato.',
    simpleOperationsWhenPixHired: 'With it, you can receive payments simply and integrated with your ERP.',
    availableOnlyWhenPaymentsHired: 'This configuration is only available for those who have already hired the Payments service.',
    simpleOperationsWhenPaymentsHired: 'With it, you can automate your payment flow simply and integrated with your ERP.',
    sasNotFoundClientInformations:
      'To validate the Fintech service contract, you need to have an active license server. Check your license and the connection status to the license server.',
    notInBetaDescription:
      'This feature is in a testing phase (Beta) with a limited group of customers and will be available to everyone soon. If you are interested in being a Beta tester for this feature, please contact your Relationship Manager.',
  },
};

export default FintechNotHiredI18n;
